import { createImageUrlBuilder, type SanityImageSource } from '@sanity/image-url'
import { dataset, projectId } from './client'

// Use a placeholder when unconfigured so the builder constructs cleanly; urlFor
// is only ever called with real Sanity image data, which won't exist then.
const builder = createImageUrlBuilder({ projectId: projectId || 'placeholder', dataset })

export function urlFor(source: SanityImageSource) {
  return builder.image(source).auto('format').fit('max')
}

export function imageProps(source: SanityImageSource | undefined | null, width = 1600) {
  if (!source) return null
  const url = urlFor(source).width(width).url()
  const alt = (source as { alt?: string })?.alt || ''
  return { src: url, alt, width, height: Math.round((width * 9) / 16) }
}
